// Description: This page is responsible for showing the options of channels that the user can use to send the templates
// Updated: 17/07/2025

// React
import React from "react";

// Material UI Components
import Box from "@mui/material/Box";

// Components and Functions for the project
import Titles from "../../components/Titles/Titles";
import HeaderPage from "../../components/HeaderPage/HeaderPage";

// Colors of the theme
import ThemeColors from "../../components/ThemeColors/ThemeColors";
import Footer from "../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import CardListG from "../../components/CardList/CardListG";
import use123zapStore from "../../context/123zapStore";

const PageOptionsChannel = (props) => {
  const Navigate = useNavigate();
  const planoAtual = use123zapStore((state) => state.planoAtual);

  const mapPlanFunctionsAllowed = {
    FreeZap: [],
    StartZap: ["WhatsApp Web"],
    ProZap: ["WhatsApp Web", "WhatsApp API"],
    UltraZap: ["WhatsApp Web", "WhatsApp API", "SMS", "Email"],
  };

  const canAddModel = (channel) => {
    if (!mapPlanFunctionsAllowed[planoAtual]) {
      return false;
    }
    return mapPlanFunctionsAllowed[planoAtual].includes(channel);
  };
  const data = [
    {
      title: "WhatsApp Web",
      subtitle: "Modelos simples para WhatsApp",
      text: "Envie textos, imagens, vídeos e documentos para seus clientes de forma rápida e segura.",
      icon: "WhatsApp",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: () => Navigate("/modelos/canal/whatsapp-web"),
      pago: canAddModel("WhatsApp Web"),
    },
    {
      title: "WhatsApp API",
      subtitle: "Modelos completos para WhatsApp",
      text: "Envie mensagens únicas, ideal para comunicações diretas e automações.",
      icon: "WhatsApp Business",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: () => Navigate("/modelos/canal/whatsapp-api"),
      pago: canAddModel("WhatsApp API"),
    },
    {
      title: "Email",
      subtitle: "Modelos simples para e-mails",
      text: "Templates de e-mail versáteis para marketing, notificações ou comunicações corporativas.",
      icon: "Email",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: () => Navigate("/modelos/canal/email"),
      pago: canAddModel("Email"),
    },
    {
      title: "SMS",
      subtitle: "Mensagens curtas e notificações",
      text: "Envie mensagens de texto rapidamente para seus clientes.",
      icon: "SMS",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: () => Navigate("/modelos/canal/sms"),
      pago: canAddModel("SMS"),
    },
  ];

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "calc(100vh - 75px)", sm: "calc(100vh - 100px)" },
      }}
    >
      <HeaderPage title="Modelos" />

      <Box
        sx={{
          borderRadius: "2px",
          overflow: "hidden",
          padding: { xs: "20px", sm: "32px 32px 0px 32px" },
        }}
      >
        <Titles type="H3" color={ThemeColors.gray40} style="medium">
          Qual canal você vai utilizar?
        </Titles>
        <CardListG data={data} showText={true} />

        <div style={{ padding: "40px 0 0 0", marginTop: "auto" }}>
          <Footer />
        </div>
      </Box>
    </Box>
  );
};

export default PageOptionsChannel;
